import { render, staticRenderFns } from "./TreasuryAdd.vue?vue&type=template&id=beaf7d74&scoped=true&"
import script from "./TreasuryAdd.vue?vue&type=script&lang=js&"
export * from "./TreasuryAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beaf7d74",
  null
  
)

export default component.exports